import React from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'
import useKpisView from './useKpisView'
import './styles.scss'

const KpisView = () => {
  const { items, isLoading } = useKpisView()
  return (
    <div className='kpis'>
      <h3 className='kpis__title'>{I18n.t('dashboard_kpis_panels')}</h3>
      {
        isLoading ? (
          <div className='kpis__loading'>
            <Nixi1Spinner width='15px' height='15px' />
          </div>
        ) : (
          <section className='kpis__section'>
            {
              items.map((card, index) => {
                return(
                  <div key={index} className='kpis__section__card'>
                    <div className='kpis__section__card--header'>
                      <figure>
                        <img src={getStaticImage(`/icons/orange-brand/${card.iconURL}.svg`)} alt={card.title} />
                      </figure>
                      <h4>{I18n.t(card.title)}</h4>
                    </div>
                    <div className='kpis__section__card--content'>
                      <p>{I18n.t(card.description)}</p>
                      <div className='kpis__section__card--content--link'>
                        <a title={`${card.title} - ${card.panelURL}`} href={card.panelURL} target='_blank' rel='noopener noreferrer' >
                          <figure>
                            <img src={getStaticImage('/icons/orange-brand/icon-kpis-panels-arrow-right.svg')} alt={card.title} />
                          </figure>
                        </a>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </section>
        )
      }
    </div>
  )
}

export default KpisView
